import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";

/**
 * The two controls every filter bar is built from.
 *
 * Extracted when the third list screen wanted them. Kept together in one file
 * because they are always used together: a labelled slot and the select that
 * usually sits in it.
 */

/** A labelled slot in a filter bar. */
export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="space-y-1.5">
      <span className="block text-xs font-medium text-muted-foreground">{label}</span>
      {children}
    </div>
  );
}

/**
 * A select whose empty state is a real option rather than a cleared value.
 *
 * Base UI models "nothing selected" as null, so the "any" row carries value
 * null and comes back through onValueChange as null -- which is exactly the
 * shape a URL patch wants for "drop this key".
 */
export function FilterSelect({
  value,
  onValueChange,
  options,
  placeholder,
  className,
}: {
  value: string | null;
  onValueChange: (value: string | null) => void;
  options: { value: string; label: string }[];
  placeholder: string;
  className?: string;
}) {
  return (
    <Select
      value={value}
      onValueChange={(next) => onValueChange((next as string | null) ?? null)}
      items={[{ value: null, label: placeholder }, ...options]}
    >
      <SelectTrigger className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={null}>{placeholder}</SelectItem>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
